import {Emitter} from './Emitter';

window.evite = window.evite || {};
const evite = window.evite;

if (evite.history) {
  throw new Error(
    'Unexpected copy of evite.history module exported, you might have used an unusual import instead of the "evite" alias.'
  );
}

const windowHistory = window.history;

export class History extends Emitter {
  get length() {
    return windowHistory?.length || 0;
  }

  get state() {
    return windowHistory?.state || null;
  }

  back() {
    windowHistory?.back?.();
  }

  forward() {
    windowHistory?.forward?.();
  }

  go(index) {
    windowHistory?.go?.(index);
    this.dispatchEvent(new CustomEvent('change'));
  }

  pushState(...args) {
    windowHistory?.pushState?.apply?.(windowHistory, args);
    this.dispatchEvent(new CustomEvent('change'));
  }

  replaceState(...args) {
    windowHistory?.replaceState?.apply?.(windowHistory, args);
    this.dispatchEvent(new CustomEvent('change'));
  }
}

export const history = new History();
